import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ErrorService {
  private _open = false;

  get open() {
    return this._open;
  }

  showError() {
    this._open = true;
  }

  hideError() {
    this._open = false;
  }
}
